import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { Supplier } from "../models/Supplier";

export const getSuppliers = async ({
	id = null,
}: {
	id?: number | null;
} = {}): Promise<Supplier[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: false }];

	if (id) {
		parameters.push({ name: "Id", value: id });
	}

	const resp = await apiService.callV2("[MILL].[GetSuppliers]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Supplier[];
	}
	throw new Error(resp.message || "Error fetching suppliers");
};

export const upsertSupplier = async (supplier: Supplier): Promise<Supplier> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: supplier.Id },
		{ name: "Name", value: supplier.Name },
		{ name: "ShortName", value: supplier.ShortName },
		{ name: "Number", value: supplier.Number },
		{ name: "Address1", value: supplier.Address1 },
		{ name: "Address2", value: supplier.Address2 },
		{ name: "Address3", value: supplier.Address3 },
		{ name: "Address4", value: supplier.Address4 },
		{ name: "City", value: supplier.City },
		{ name: "State", value: supplier.State },
		{ name: "Zip", value: supplier.Zip },
		{ name: "Country", value: supplier.Country },
		{ name: "Tel", value: supplier.Phone },
		{ name: "Fax", value: supplier.Fax },
		{ name: "ContactName", value: supplier.Contact },
		{ name: "ContactName2", value: supplier.ContactName2 },
		{ name: "Active", value: supplier.Active },
	];

	const resp = await apiService.callV2("[MILL].[UpsertSupplier]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as Supplier;
	}
	throw new Error(resp.message || "Error saving supplier");
};

export const removeSupplier = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2("[MILL].[RemoveSupplier]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting supplier");
	}
};
